import React, { useEffect } from "react";
import { Button, Nav } from "react-bootstrap";
import { FaBars, FaSearch, FaTimes } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import { AccountDropdown } from "./AccountDropdown";
import gaTracker from "../../util/ga-analytics/gaTracker";
import { useHistory } from "react-router-dom";
export var MobileAppSideMenu = function MobileAppSideMenu(props) {
  var searchActive = props.searchActive,
      mobile = props.mobile,
      handleLogin = props.handleLogin,
      handleShowModal = props.handleShowModal,
      handleAccoount = props.handleAccoount,
      handleShowSidebar = props.handleShowSidebar,
      closeSearch = props.closeSearch,
      displaySearch = props.displaySearch,
      accountInfo = props.accountInfo,
      authenticationState = props.authenticationState,
      showSearchButton = props.showSearchButton,
      showHamburgerButton = props.showHamburgerButton,
      showCartButton = props.showCartButton,
      _props$cartLength = props.cartLength,
      cartLength = _props$cartLength === void 0 ? 0 : _props$cartLength;
  useEffect(function () {}, [cartLength]);
  var history = useHistory();

  var hamburgerMenuClick = function hamburgerMenuClick() {
    handleShowSidebar(true);
    var data = {
      gtm: {
        uniqueEventId: "21",
        elementId: "cb-header__hamburger"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var signInClick = function signInClick() {
    handleLogin();
    var data = {
      gtm: {
        uniqueEventId: "7",
        elementId: "cb-header__signin"
      },
      event: "gtm.click"
    };
    gaTracker(data);
  };

  var cartClick = function cartClick() {
    var data = {
      gtm: {
        uniqueEventId: "20",
        elementId: mobile ? "banner-cart" : "banner-cart-mobile"
      },
      event: "gtm.click"
    };
    gaTracker(data);
    history.push('/cart');
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row-reverse align-items-end"
  }, showHamburgerButton && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: hamburgerMenuClick,
    id: "cb-header__hamburger",
    className: "cb-button-unstyled cb-header__button pr32"
  }, /*#__PURE__*/React.createElement(FaBars, {
    className: "cb-color-brown-500",
    size: 30
  }))), showCartButton && /*#__PURE__*/React.createElement("a", {
    href: "#",
    id: mobile ? "banner-cart" : "banner-cart-mobile",
    onClick: cartClick,
    className: "position-relative pr-3"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-button__shop-mobileapp"
  }, "Cart"), Boolean(cartLength) && /*#__PURE__*/React.createElement("span", {
    className: "cb-header__cart-indicator"
  }, cartLength)), showSearchButton && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-unstyled cb-header__button pr-3",
    onClick: displaySearch
  }, /*#__PURE__*/React.createElement(FaSearch, null)), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick(e) {
      return closeSearch();
    },
    className: "\n        float-right\n        cb-header__search-close\n        cb-header__button\n        cb-button-unstyled\n        ".concat(!searchActive ? "is-hidden" : "", "\n        ")
  }, /*#__PURE__*/React.createElement(FaTimes, {
    className: "fa-3x"
  })))));
};